var $8bdaeb71e50c3e1a$exports = {};
$8bdaeb71e50c3e1a$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " neselectat.");
  },
  "longPressToSelect": "Ap\u0103sa\u021Bi lung pentru a intra \xEEn modul de selectare.",
  "select": "Selectare",
  "selectedAll": "Toate elementele selectate.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Niciun element selectat",
      one: function one() {
        return "".concat(formatter.number(args.count), " element selectat");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elemente selectate");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " selectat.");
  }
};
export { $8bdaeb71e50c3e1a$exports as default };